
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

export interface BasicDataKeyValue {
  value: string | number,
  key?: string
}

@Component({
  name: 'FieldBasicData',
})
export default class FieldBasicData extends Vue {
  @Prop({ default: () => [] })
  private data: BasicDataKeyValue[]

  @Prop({ default: false })
  private refuel: boolean;
}
